module.exports = __webpack_public_path__ + "static/Screenshot (68)-19d3cca082059864318222e504684f7a.png";